// extracted by mini-css-extract-plugin
export default {"summary":"TaskSyncFilePage_summary__luOYA","title":"TaskSyncFilePage_title__gezQ-"};